import {
  AgentInSinglePaymentProviderContext,
  getAgentById,
  getAgentInSinglePaymentProviderContextByAgentId,
  patchSetAgentInSinglePaymentProviderContextById,
  postCreateAgentInSinglePaymentProviderContext,
} from '@nemuru-eng/js-api-client';
import { v4 as uuidv4 } from 'uuid';

import { AddAgentInSinglePaymentProviderContextCredentialsFormType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/schemas/AddAgentInSinglePaymentProviderContextCredentialsForm.schema';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';
interface UseAddOrEditAgentInSinglePaymentProviderContextProps {
  agentId: string;
  selectedAgentInSinglePaymentProviderContext?: AgentInSinglePaymentProviderContext;
}
export const useAddOrEditAgentInSinglePaymentProviderContext = ({
  agentId,
  selectedAgentInSinglePaymentProviderContext,
}: UseAddOrEditAgentInSinglePaymentProviderContextProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getAgentInSinglePaymentProviderContextByAgentId, { agentId });
  const { data: agent } = useCache(getAgentById, { agentId });
  const createOrUpdateAgentInSinglePaymentProviderContext = async (
    formValues: AddAgentInSinglePaymentProviderContextCredentialsFormType,
  ) => {
    try {
      if (selectedAgentInSinglePaymentProviderContext) {
        const agentInLenderContextRequest = getRequestPayload(
          formValues,
          selectedAgentInSinglePaymentProviderContext.id,
        );
        await request(patchSetAgentInSinglePaymentProviderContextById, agentInLenderContextRequest);
      } else {
        const agentInLenderContextRequest = getRequestPayload(formValues);
        await request(postCreateAgentInSinglePaymentProviderContext, agentInLenderContextRequest);
      }
    } catch (error) {
    } finally {
      revalidate();
    }
  };
  const getRequestPayload = (
    formValues: AddAgentInSinglePaymentProviderContextCredentialsFormType,
    agentInLenderContextId: string | undefined = undefined,
  ) => {
    return {
      agentId,
      id: agentInLenderContextId ?? (uuidv4() as string),
      providerId: formValues.providerId,
      paymentMethodType: formValues.paymentMethodType,
      ...(formValues.productId && formValues.merchantId && formValues.merchantKey && formValues.merchantPassword
        ? {
            configuration: {
              productId: formValues.productId,
              merchantId: formValues.merchantId,
              merchantKey: formValues.merchantKey,
              merchantPassword: formValues.merchantPassword,
            },
          }
        : {}),
    };
  };
  return { createOrUpdateAgentInSinglePaymentProviderContext, loading, agent };
};
